import { isNil } from 'lodash';
import moment from 'moment';

import { User, UserStatuses } from 'src/models/Users/User';

const maxTokenAgeHours = 24;

const getMaxTokenAgeHours = () => {
  return maxTokenAgeHours;
};

const isUserActivationExpired = (user: User) => {
  const currentTime = moment();
  return currentTime.diff(moment(user.activationSentAt), 'hours') > getMaxTokenAgeHours();
};

const isUserActivated = (user: User) => {
  return !isNil(user.activatedAt);
};

const isUserDisabled = (user: User) => {
  return !isNil(user.disabledAt);
};

const statusMap = {
  ACTIVE: user => !isUserDisabled(user) && isUserActivated(user),
  INACTIVE: user => !isUserDisabled(user) && !isUserActivated(user) && !isUserActivationExpired(user),
  DISABLED: user => isUserDisabled(user),
  INVITE_EXPIRED: user => !isUserDisabled(user) && !isUserActivated(user) && isUserActivationExpired(user),
};

export const getUserStatus = (user: User): UserStatuses => {
  for (const [key, func] of Object.entries(statusMap)) {
    if (func(user)) {
      return UserStatuses[key];
    }
  }
  return UserStatuses.ACTIVE;
};
